import React from 'react';

const Sept4_1982Page = () => {
  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fas fa-flag-usa"></i>
          September 4, 1982 - The American Dream
        </h1>
        <p>Reflecting on the foundations of the American Dream and our family's journey.</p>
      </div>

      <div className="page-content">
        <div className="section">
          <div className="american-dream-content">
            <p className="welcome-text">
              September 4, 1982 takes us back to an earlier chapter in our American Dream story.
              This date reminds us of the foundations that were laid and the dreams that
              were beginning to take shape.
            </p>

            <div className="story-section">
              <h3>Early Dreams, Lasting Impact</h3>
              <p>
                In 1982, America was a land of opportunity for those willing to work hard
                and dream big. September 4th of that year represents the early stages
                of our family's pursuit of something greater.
              </p>
              
              <p>
                The American Dream has always been about more than material success.
                It's about the promise that with dedication, integrity, and perseverance,
                you can build a life of meaning and purpose.
              </p>

              <div className="historical-context">
                <h4>The America of 1982:</h4>
                <p>
                  This was a time of economic challenges but also great opportunity.
                  Families like ours were laying the groundwork for future success,
                  building businesses, raising children, and contributing to their communities.
                </p>
              </div>

              <div className="legacy-section">
                <h4>Building a Legacy:</h4>
                <p>
                  The decisions made and dreams pursued on days like September 4, 1982
                  created the foundation for everything that followed. Each step forward
                  was an investment in our family's future and a testament to the
                  enduring power of the American Dream.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sept4_1982Page;